module.exports = __webpack_public_path__ + "static/media/ball-triangle.5ef85071.svg";